export default __webpack_public_path__ + "static/media/icon-trash.7c5db9ba.svg";